<template lang="pug">
.user-profile

  h2 用户信息

  h3 {{ $formatters.user_name(user) }}
  p 角色: {{ $formatters.user_role(user) }}

  el-tabs(v-model='tabs')
    el-tab-pane(:name='null', label='权限列表')
      .ui.relaxed.divided.list
        .item(v-for='per in permissions', :class='{disabled:!$permission.has(per.key)}')
          i.large.checkmark.middle.aligned.icon.themed.text(v-if='$permission.has(per.key)')
          i.large.minus.middle.aligned.icon(v-else)
          .content
            .header {{per.key}}
            .description {{per.name}}

  br
  br
  br
</template>

<script>
import { permissions } from '../shared'

export default {
  name: 'user-profile',
  data() {
    return {
      permissions,
      tabs: null,
    }
  },
  computed: {
    user() {
      return this.$user
    },
  },
}
</script>



// WEBPACK FOOTER //
// UserProfile.vue?5f0b1436